import {
  GET_SUBSCRIPTION_PLAN,
  PAUSE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_PLAN,
  SUBSCRIPTION_FEEDBACK_REQUEST,
  CREATE_BILLING_CHECKOUT,
  APPLY_BILLING_PLAN_CHANGE,
  OPEN_BILLING_MANAGEMENT,
  GET_BILLING_PLANS,
} from "../../utils/constants";

// ------------------------------------
// Actions
// ------------------------------------

export function getSubscriptionPlan(value) {
  return {
    type: GET_SUBSCRIPTION_PLAN,
    payload: value,
  };
}

export const upgradePlan = (data) => {
  return {
    type: UPDATE_SUBSCRIPTION_PLAN,
    payload: data,
  };
};

export const pauseSubscription = (data) => {
  return {
    type: PAUSE_SUBSCRIPTION,
    payload: data,
  };
};

export const submitSubscriptionFeedback = (data) => {
  return {
    type: SUBSCRIPTION_FEEDBACK_REQUEST,
    payload: data,
  };
};

export const createBillingCheckout = (data) => {
  return {
    type: CREATE_BILLING_CHECKOUT,
    payload: data,
  };
};

export const applyBillingPlanChange = (data) => ({
  type: APPLY_BILLING_PLAN_CHANGE,
  payload: data,
});

export const openBillingManagement = (data) => {
  return {
    type: OPEN_BILLING_MANAGEMENT,
    payload: data,
  };
};

export const getBillingPlans = () => ({
  type: GET_BILLING_PLANS,
});

export const actions = {
  getSubscriptionPlan,
  upgradePlan,
  pauseSubscription,
  submitSubscriptionFeedback,
  createBillingCheckout,
  applyBillingPlanChange,
  openBillingManagement,
  getBillingPlans,
};
